const PUSH_NOTIFICATIONS = "PUSH_NOTIFICATIONS";
const PUSH_NOTIFICATIONS_SUCCESS = "PUSH_NOTIFICATIONS_SUCCESS";
const PUSH_NOTIFICATIONS_FAILURE = "PUSH_NOTIFICATIONS_FAILURE";
const CLEAR_PUSH_NOTIFICATIONS = "CLEAR_PUSH_NOTIFICATIONS";

const PushNotificationsSymbols = {
  PUSH_NOTIFICATIONS_SUCCESS,
  PUSH_NOTIFICATIONS_FAILURE,
  PUSH_NOTIFICATIONS,
  CLEAR_PUSH_NOTIFICATIONS,
};
export default PushNotificationsSymbols;
